// FlixDetailList.js
import { connect } from 'react-redux';

import FlixDetailList from '../component/FlixDetailList.jsx';
import getNetworkingData from '../selector/getNetworkingData.js';
import getListData from '../selector/getListData.js';
import getOperationData from '../selector/getOperationData.js';
import getFeedName from '../selector/getFeedName.js';
import { getSelectedQueryOptionObject } from '../selector/getFeedQueryObject.js';
import getRemoteConfigData from '../selector/getRemoteConfigData.js';
import fetchUnlockedMessages from '../action/fetchUnlockedMessages.js';
import fetchFeeds, { getReturnType } from '../action/fetchFeeds.js';
import { freezoneFeed } from '../resource/freezoneConstants.js';
import {
  ProfileListType,
  PROFILE_FEED_REMOTE_CONFIG_KEY_MAP,
} from '../resource/profileConstants.js';
import { QueryPrefix, QueryType } from '../resource/feedConstants.js';

const mapStateToProps = (state, { userId, listType, messageId }) => {
  const recommendFlixCategory = getOperationData(
    state,
    ['recommendFlixCategory'],
    'flixDetail'
  );
  const outboxRemoteConfigKeyName =
    PROFILE_FEED_REMOTE_CONFIG_KEY_MAP[ProfileListType.FLIX];
  const outboxBaseFeedName = getFeedName(
    state,
    outboxRemoteConfigKeyName,
    '{USER_ID}',
    userId
  );
  const {
    intersectedFeedName: outboxIntersectedFeedName,
    filters: outboxFilters,
    sorts: outboxSorts,
  } = getSelectedQueryOptionObject(
    state,
    outboxBaseFeedName,
    undefined,
    getRemoteConfigData(
      state,
      `${outboxRemoteConfigKeyName}_${QueryPrefix[QueryType.SORT]}`
    )?.[0]
  );
  const selectPath =
    listType === 'pro'
      ? ['home', 'messages', freezoneFeed.MODEL]
      : listType === 'unlocked'
      ? ['unlocked', 'messages', 'flix', userId] // unlocked
      : listType === 'outbox'
      ? [
          'home',
          getReturnType({ feedName: outboxIntersectedFeedName }),
          outboxIntersectedFeedName,
        ] // outbox
      : listType === 'relatedMessages'
      ? ['home', 'messages', `message-${messageId}`] // related message
      : ['home', 'messages', recommendFlixCategory]; // feed

  const nextPage = getListData(state, selectPath, 'nextPage');
  const unlockedIds = getListData(
    state,
    ['unlocked', 'messages', 'flix', userId],
    'itemIds'
  );
  const filterIds =
    listType === 'unlocked' ? [messageId] : [messageId].concat(unlockedIds);
  // TODO: fix messageIds always new array issue.
  const messageIds = getListData(state, selectPath, 'itemIds', filterIds);

  return {
    outboxIntersectedFeedName,
    userId,
    listType,
    recommendFlixCategory,
    messageId,
    outboxFilters,
    outboxSorts,
    messageIds,
    isFetching: getNetworkingData(
      state,
      [...selectPath, nextPage],
      'isFetching'
    ),
    isFirstPageFetching: getNetworkingData(
      state,
      [...selectPath, 1],
      'isFetching'
    ),
    isFirstPageFetched: getNetworkingData(
      state,
      [...selectPath, 1],
      'isFetched'
    ),
    nextPage,
  };
};

const mapDispatchToProps = dispatch => {
  return {
    fetchUnlockedMessages: data => dispatch(fetchUnlockedMessages(data)),
    fetchFeeds: data => dispatch(fetchFeeds(data)),
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(FlixDetailList);
